module.exports = __webpack_public_path__ + "static/img/social_index_banner.9797987.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteJob/social_index_banner.png
// module id = 2glL
// module chunks = 34